import { Configuration, ResponseError } from "./sdk";

import { AuthenticationService } from "../authentication.ts";
import { useAuthStore } from "@/store/auth.ts";
import { useClientConfig } from "@/store/client-config.ts";

export const ApiConfiguration = new Configuration({
  basePath: import.meta.env.VITE_API_URL,
  accessToken: async () => {
    const authStore = useAuthStore();

    if (AuthenticationService.requiresTokenRefresh()) {
      try {
        await authStore.setUser(
          await AuthenticationService.handleTokenRefresh(),
        );
      } catch (error: any) {
        console.error(error);
        await AuthenticationService.loginRedirect();
      }
    }

    return authStore.bearerToken || "";
  },
  middleware: [
    {
      async pre(context) {
        const clientConfig = useClientConfig();
        const authStore = useAuthStore();

        const additionalHeaders: Record<string, string> = {};

        if (clientConfig.selectedTenant !== -1) {
          additionalHeaders['X-Tenant-Id'] = clientConfig.selectedTenant.toString();
        }

        if (authStore.roleOverride) {
          additionalHeaders['X-Role'] = authStore.roleOverride;
        }

        return {
          url: context.url,
          init: {
            ...context.init,
            headers: {
              ...context.init.headers,
              ...additionalHeaders,
            },
          },
        };
      },
    },
  ],
});

export function isResponseError(e: any): e is ResponseError {
  return !!e.response;
}
